import { render, staticRenderFns } from "./contentEdit.vue?vue&type=template&id=54eda7ea"
import script from "./contentEdit.vue?vue&type=script&lang=js"
export * from "./contentEdit.vue?vue&type=script&lang=js"
import style0 from "./contentEdit.vue?vue&type=style&index=0&id=54eda7ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports